import React from "react";
import {useParams,useRoute,useBCMSContext,BCMSRecord} from "@bcm-dev/bcms-vite";
import { Card,LinkedAccount } from "model";
import { SVGAsset } from "res";
import { UIPrimaryButton } from "components/ui/UIButton";

import "./styles.css";

/**
 * @function PaymentAccountDetailsView
 * @param {STRING} lastFour - Sets the last four of the account number.
 * @param {STRING} fiName - Sets the financial institution name.
 * @param {STRING} accountName - Sets the account name.
 * @param {STRING} routingNum - Sets the routing number.
 * @returns {React.Component}
 * @description This is the account details sub-page in the ManagePaymentAccountsPage.
 * @exported true
 */
export default function PaymentAccountDetailsView(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor([ Card  ,LinkedAccount ], globalController);
    const cardID = useParams().cardID ?? 0;
    const accountID = useParams().accountID ?? 0;
    const card = Card.initByID(cardID);
    const account = LinkedAccount.initByID(accountID);
    const lastFour = account.last_four_digit_number ?? "[last four]";
    const fiName = account.fi_name ?? "[fI Name]";
    const accountName = account.type ?? "[account]";
    const routingNum = account.routing_number ?? "[routing]";
    const navigate = useRoute();
    return (
        <div className="payment-account-details-view">
            <div className="flex-container flex-vertical">
                <div className="flex-width circle-icon">
                    <div className="framed-icon-container">
                        <SVGAsset id="OutlineCardIcon" />
                        <SVGAsset id="CheckmarkCircleIcon" className="CheckmarkCircleIcon" />
                    </div>
                </div>
                <div className="flex-width header">
                    <p className="text-center"><b>Account Details {lastFour}</b></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal financial-institution-container">
                <div className="flex-width">
                    <p className="grey-label"><span>Financial Institution</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span>{fiName}</span></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal payment-account-container">
                <div className="flex-width">
                    <p className="grey-label"><span>Payment Account</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span className="capitalize">{accountName} {lastFour}</span></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal routing-number-container">
                <div className="flex-width">
                    <p className="grey-label"><span>Routing Number</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span>{routingNum}</span></p>
                </div>
            </div>
            <div className="flex-container column-space-around-container button-container">
                <UIPrimaryButton text="Done" onClick={()=> navigate(-1)} />
            </div>
        </div>
    )
}
